<template>
	<v-app id="zarinpalCallback-view" fluid tag="section">
		<v-app-bar color="secondary" dark dense style="max-height: 48px">
			<a href="/" class="d-flex align-center">
				<img src="/logo-wide.png" style="max-width: 80px; max-height: 32px" class="hidden-sm-and-down" />

				<!-- نسخه کوچکتر برای موبایل -->
				<img src="/logo-wide.png" style="max-width: 60px; max-height: 28px" class="hidden-md-and-up" />
			</a>
			<div class="">
				<strong>اعتبارسنجی و پردازش پرداخت آنلاین</strong>
				&nbsp;&nbsp;
				<span class="warning--text text-truncate">{{ longTitle }}</span>
			</div>
		</v-app-bar>
		<v-container>
			<v-row align="center" justify="center">
				<v-col cols="10" md="6">
					<v-card ref="card" class="mx-auto my-12">
						<div class="d-flex flex-column justify-center align-center" style="height:200px;" :style="{ 'background-color': bg }">
							<v-icon size="large" :color="color" style="font-size: 100px;">
								{{ icon }}
							</v-icon>
							<p :style="{ color: color }">{{ title }}</p>
						</div>
						<div class="form-group text-center py-5">
							<div v-if="message" v-html="message">

							</div>
							<p v-if="!isSuccess && isSuccess != null" class="grey--text px-5 pt-10"><small>در صورت کسر وجه٬ تراکنش به طور خودکار و حداکثر تا ۷۲ ساعت به حساب شما بازگشت داده ميشود. در صورت بروز مشکل پس از زمان مذکور با ما تماس بگيريد.</small></p>
						</div>
						<v-card-actions class="my-10">
							<v-spacer />
							<v-btn ref="submit" color="secondary" :loading="loading" dark @click="returnToPanel()">
								بازگشت به پنل کاربری
							</v-btn>
							<v-spacer />
						</v-card-actions>
					</v-card>
				</v-col>
			</v-row>
		</v-container>
	</v-app>
</template>

<script>
	import GatewayService from '@/services/gateway.service'
	import { get } from 'vuex-pathify'
	import ThemeManager from '@/util/theme-manager.js'

	export default {
		name: 'ZarinpalCallback',
		data() {
			return {
				data: { status: '', authority: '' },
				loading: false,
				isSuccess: null,
				message: '',
			}
		},
		computed: {
			...get('siteConfig', [
				'longTitle'
			]),
			bg() {
				if (this.loading)
					return '#dadada'
				if (this.isSuccess)
					return 'rgb(182 255 193)'
				return 'rgb(255 227 227)'
			},
			color() {
				if (this.loading)
					return '#aaa'
				if (this.isSuccess)
					return '#0dd400'
				return '#ff5722'
			},
			icon() {
				if (this.loading)
					return 'mdi-timer-sand'
				if (this.isSuccess)
					return 'mdi-credit-card-check'
				return 'mdi-alert-circle-outline'
			},
			title() {
				if (this.loading)
					return 'در حال بررسی'
				if (this.isSuccess)
					return 'پرداخت موفق'
				return 'پرداخت ناموفق'
			}
		},
		created() {
			ThemeManager.ApplyThemeSettings(this.$route.params.customerCode || 0, this.$vuetify)
		},
		mounted() {
			this.data.status = this.$route.query.Status
			this.data.authority = this.$route.query.Authority
			if (!this.data.status || !this.data.authority) {
				this.isSuccess = false
				this.message = 'پارامترهای مورد نیاز یافت نشدند.'
				return
			}
			this.verify()
			// this.$refs.password.$el.querySelector('input').click()
		},
		methods: {
			verify() {
				this.message = 'لطفا تا پایان عملیات منتظر بمانید...',
					this.loading = true
				GatewayService.verifyZarinPal(this.data).then(
					response => {
						this.loading = false
						this.isSuccess = true
						this.message = 'با تشکر، پرداخت با موفقیت انجام شد و خرید شما اعمال شد.<br/>شماره تراکنش: ' + response
					})
					.catch(error => {
						this.isSuccess = false
						this.loading = false
						this.message = error.message || error.toString()
					})
			},
			returnToPanel() {
				if (this.isSuccess) {
					this.$router.push('/login')
					return
				}
				this.$router.push('/admin/dashboard')
			}
		},
	}
</script>

<style scoped></style>
